import { Turbo } from "@hotwired/turbo-rails";
import TurboPower from "turbo_power";
import "../controllers";

TurboPower.initialize(Turbo.StreamActions);
